import { useQuery } from '@tanstack/react-query'
import {
    GetRegisteredTargetParams,
    RegisteredDestinationsResponse
} from '../services/destination/destination.types'
import destinationService from '../services/destination/destination.service'

interface UseRegisteredDestinationsParams
    extends GetRegisteredTargetParams {
    enabled?: boolean
}

export const useRegisteredDestinations = (
    params?: UseRegisteredDestinationsParams
) => {
    const {
        enabled = true,
        ...queryParams
    } = params || {}

    return useQuery<RegisteredDestinationsResponse>({
        queryKey: ['registered-destinations', queryParams],
        queryFn: () =>
            destinationService.getRegisteredDestinations(queryParams),
        enabled,
        staleTime: Infinity,
    })
}